import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/myanmar/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/myanmar/images/heroBg.png";

import myanmar from "../../images/v4/country/myanmar/icons/myanmar.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/myanmar/images/countryBackground.png";
import benefitImg from "../../images/v4/country/myanmar/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/myanmar/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/myanmar/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/myanmar/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/myanmar/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background:
        "linear-gradient(90deg, #00B661 66.37%, #FFB54B 81.73%, #FF1D5A 96.98%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#F9F5FC",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #FF7D47 -1.52%, #7430AA 109.91%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "90%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "strch",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "180px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Myanmar = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "What is the leading CRM software for small businesses operating in Myanmar?",
      answer: (
        <>
          Pepper Cloud CRM is specifically designed for Myanmar SMES, offering a
          powerful, affordable platform that supports growth, automation, and
          efficient customer relationship management tailored to the local
          business environment.
        </>
      ),
    },
    {
      question: "How can my growing Myanmar business start using a CRM?",
      answer: (
        <>
          Getting started with Pepper Cloud CRM in Myanmar is simple and
          hassle-free. Whether you’re launching a new venture or scaling a
          mature business, our CRM makes managing leads, pipelines, and client
          relationships seamless.
          <ul>
            <li>
              Book a free demo for a personalised walkthrough of Pepper Cloud
              CRM.
            </li>
            <li>
              Speak with our Myanmar CRM consultants to find the best-fit plan
              for your business.
            </li>
            <li>
              Experience an easy setup process with no hidden costs or tech
              complexity.
            </li>
            <li>
              Customise workflows, fields, and pipelines to match your local
              sales process.
            </li>
            <li>
              Go live quickly and start accelerating growth using AI-powered
              features and integrations.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "What should Myanmar businesses consider when choosing a CRM?",
      answer: (
        <>
          <ul>
            <li>
              Scalability: Choose a CRM that grows with your business and team
              expansion.
            </li>
            <li>
              Customisation: Ensure it fits your industry-specific workflows and
              Myanmar sales practices.
            </li>
            <li>
              Tool compatibility: Look for integration with WhatsApp, email
              platforms, and Google Workspace.
            </li>
            <li>
              Local support access: Prioritise CRM providers with
              Myanmar-specific guidance and support.
            </li>
            <li>
              Fair pricing: Select a CRM with transparent pricing and real
              value—no hidden fees.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for Myanmar startups?",
      answer: (
        <>
          Absolutely. Pepper Cloud CRM is ideal for Myanmar startups. It's easy
          to implement, cost-effective, and includes automation tools that help
          small teams convert leads and scale faster with minimal manual effort.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud CRM work with the tools I already use?",
      answer: (
        <>
          Yes. Pepper Cloud CRM connects smoothly with widely used tools like
          Google Workspace, email services, web forms, and marketing platforms,
          offering a seamless operational ecosystem for Myanmar businesses.
          Learn more about supported{" "}
          <a href="https://peppercloud.com/crm-integrations" target="_blank">
            integrations
          </a>
          .
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM ensure data security for Myanmar businesses?",
      answer: (
        <>
          Pepper Cloud CRM uses enterprise-grade encryption and security
          protocols to protect your data. It helps businesses in Myanmar comply
          with best practices in data protection and client privacy.
        </>
      ),
    },
    {
      question: "Which CRM platforms are most popular in Myanmar?",
      answer: (
        <>
          While global CRMs are available, Pepper Cloud CRM is rapidly emerging
          as the preferred choice among Myanmar SMEs due to its WhatsApp
          integration, automation, affordability, and dedicated local support.
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM affordable for small and medium-sized companies?",
      answer: (
        <>
          Yes. Pepper Cloud CRM offers flexible pricing plans to fit businesses
          at every stage in Myanmar—from bootstrapped startups to scaling
          enterprises—ensuring maximum value without overpaying for unused
          features.
        </>
      ),
    },
    {
      question: "What defines the best CRM for small businesses in Myanmar?",
      answer: (
        <>
          The ideal CRM should be affordable, easy to use, scalable, and
          local-market ready. Pepper Cloud CRM ticks all these boxes, offering
          an intuitive interface, smart automation, and built-in communication
          tools to manage sales and customer loyalty efficiently.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud is purpose-built for Myanmar businesses, offering AI automation, WhatsApp CRM, lead tracking, and sales pipeline tools—all in one. It supports startups, SMES, and large enterprises with scalable features, making it the top CRM solution for Myanmar's B2B landscape.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI automation suite",
          desc: "Efficiently automate workflows, lead scoring, and provide AI-driven sales assistance to improve productivity.",
        },
        {
          title: "Omnichannel CRM",
          desc: "Unify customer interactions across WhatsApp, email, Facebook, and other channels on a single platform.",
        },
        {
          title: "Pipeline management",
          desc: "Create custom deal stages, track sales performance, and forecast future revenue with visual dashboards.",
        },
        {
          title: "Seamless integrations",
          desc: "Easily integrate with tools like Google Workspace, enabling a smooth workflow across your business apps.",
        },
        {
          title: "Localisation ready",
          desc: "Fully tailored for Bahasa Indonesia and designed for local market demands, language, and culture.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM offers a free-forever plan and powerful marketing automation, making it attractive to Myanmar businesses looking for lead generation and nurturing tools.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Marketing automation",
          desc: "Build and schedule campaigns easily",
        },
        {
          title: "Pipeline management",
          desc: "Simple drag-and-drop interface",
        },
        {
          title: "CRM for teams",
          desc: "Built-in collaboration and task tools",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a global CRM platform that suits large Myanmar enterprises with complex workflows and integration needs, offering robust reporting and AI forecasting.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Einstein AI",
          desc: "Intelligent sales and customer insights",
        },
        {
          title: "Custom workflows",
          desc: "Highly adaptable for large teams",
        },
        {
          title: "Extensive ecosystem",
          desc: "Thousands of third-party app integrations",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM appeals to Myanmar’s small-to-medium businesses with its affordable pricing and modular structure. It provides great flexibility for growing B2B sales teams.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Smart automation and task reminders",
        },
        {
          title: "Sales gamification",
          desc: "Motivate your team with rewards and goals",
        },
        {
          title: "Multi-channel support",
          desc: "Manage email, calls, and social interactions",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics offers deep integration with Office 365 and Power BI, making it an attractive choice for Myanmar businesses already invested in Microsoft’s ecosystem.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "AI-powered insights",
          desc: "Predictive analytics and customer behaviour tracking",
        },
        {
          title: "Power BI visuals",
          desc: "Advanced reporting and data visualisation",
        },
        {
          title: "LinkedIn sync",
          desc: "Enhanced B2B lead engagement and outreach",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "Lead management system",
      desc: "Capture, assign, and track leads from multiple channels to streamline sales and reduce manual efforts across your team.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "AI-powered automation",
      desc: "Automate follow-ups, task assignments, and deal progression to boost productivity, reduce errors, and close sales faster with AI workflows.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline visibility",
      desc: "Visualize your sales journey with customizable stages for better forecasting, prioritization, and data-driven decisions for your team.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "WhatsApp CRM integration",
      desc: "Engage customers instantly on Myanmar’s top messaging app with automated flows, templates, and broadcasts to boost conversions.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "Multichannel communication hub",
      desc: "Centralize conversations from email, WhatsApp, Facebook, and more for seamless interactions with leads across every touchpoint.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Mobile CRM access",
      desc: "Enable remote teams to manage deals and tasks anytime, boosting agility and responsiveness on the go.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Custom workflow builder",
      desc: "Design automations that align with your sales process, from lead nurturing to deal closure, with minimal manual effort.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Activity tracking tool",
      desc: "Monitor tasks, calls, and meetings for consistent follow-ups, timely communication, and improved team accountability.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "Seamless tool integrations",
      desc: "Connect with tools like Google Workspace, email marketing platforms, and more for a unified operational ecosystem.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Client nurturing",
          content:
            "Send property updates and availability alerts via WhatsApp.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Lead segmentation",
          content:
            "Send property updates and availability alerts via WhatsApp.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Sales tracking",
          content: "Track deals, agent performance & pipeline with dashboards.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Real Estate CRM for Myanmar",
      subtitle:
        "Sales teams in Myanmar’s real estate sector can automate lead follow-ups and schedule viewings through WhatsApp. Improve response time and close more deals with centralised contact management.",
    },
    {
      tabContent: [
        {
          heading: "Class scheduling",
          content: "Send automated reminders and updates for sessions.",
          alt: "Education CRM",
        },
        {
          heading: "Lead management",
          content: "Nurture course inquiries via segmented communication.",
          alt: "Education CRM",
        },
        {
          heading: "Progress tracking",
          content:
            "Track student engagement, interests & feedback for marketing.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Education CRM for Myanmar",
      subtitle:
        "Education providers in Myanmar can use Pepper Cloud CRM to manage enrolments, student follow-ups, and learning journeys effectively.",
    },
    {
      tabContent: [
        {
          heading: "Consultation booking",
          content: "Automate meetings and document sharing for onboarding.",
          alt: "Consulting CRM",
        },
        {
          heading: "Compliance management",
          content: "Keep logs of chats and file exchanges for audit readiness.",
          alt: "Consulting CRM",
        },
        {
          heading: "Client engagement",
          content:
            "Send timely reminders, tips, and investment updates via WhatsApp & email.",
          alt: "Consulting CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Consulting CRM for Myanmar",
      subtitle:
        "Consulting firms and finance professionals can build trust with better client relationship tracking and follow-up automation.",
    },
    {
      tabContent: [
        {
          heading: "Promotional campaigns",
          content:
            "Send discount codes & flash sale alerts to segmented lists.",
          alt: "Retail CRM",
        },
        {
          heading: "Customer loyalty",
          content:
            "Track purchase history and reward loyal customers with offers.",
          alt: "Retail CRM",
        },
        {
          heading: "Omnichannel sales",
          content:
            "Sync communication from stores, Facebook, and WhatsApp to CRM.",
          alt: "Retail CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail CRM for Myanmar",
      subtitle:
        "Retailers in Myanmar can personalise customer communication and drive repeat purchases using multichannel CRM tools.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software for Myanmar businesses?",
      content:
        "A CRM is a customer management tool that helps Myanmar businesses streamline sales, improve customer interactions, and track communications through a centralised platform tailored to local business needs.",
    },
    {
      heading: "Why do businesses in Myanmar need a CRM?",
      content:
        "With evolving customer expectations and rising competition, Myanmar companies need CRM software to manage leads, automate follow-ups, and gain insights that drive smarter sales decisions and improved service delivery.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud combines lead management and sales automation into one unified platform—no need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "All-size business",
      desc: "Whether you're a startup, SME or enterprise, our CRM is tailored to suit your business stage and industry.",
      img: bestIcon2,
    },
    {
      pointer: "Affordable pricing",
      desc: "Transparent and cost-effective plans with zero setup charges—built to support Myanmar’s SMES and growing businesses.",
      img: bestIcon3,
    },
    {
      pointer: "24/7 local support",
      desc: "Get round-the-clock help from our team, who understands the Myanmar market and speaks your language.",
      img: bestIcon4,
    },
    {
      pointer: "Advanced customisation",
      desc: "Tailor the CRM with flexible workflows, custom fields, and pipeline stages to match your unique sales process.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Track leads and interactions centrally to improve team efficiency and shorten sales cycles.",
    "Automate repetitive sales tasks and workflows to increase team focus and deal closures.",
    "Gain real-time insights with visual dashboards to support smarter sales decisions.",
    "Communicate across WhatsApp, email, and social media seamlessly within one central platform.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM Software in Myanmar | Pepper Cloud CRM "}
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-myanmar/"
        }
        keywords="Best CRM Software in Myanmar,  CRM for Myanmar, Sales CRM Myanmar, CRM solution for Myanmar businesses, Myanmar customer relationship management"
        description={
          "Discover the best CRM software in Myanmar. Pepper Cloud CRM helps B2B businesses boost sales, automate workflows, and build stronger customer relationships."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the leading CRM software for small businesses operating in Myanmar?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is specifically designed for Myanmar SMES, offering a powerful, affordable platform that supports growth, automation, and efficient customer relationship management tailored to the local business environment.",
                },
              },
              {
                "@type": "Question",
                name: "How can my growing Myanmar business start using a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Getting started with Pepper Cloud CRM in Myanmar is simple and hassle-free. Whether you’re launching a new venture or scaling a mature business, our CRM makes managing leads, pipelines, and client relationships seamless.",
                },
              },
              {
                "@type": "Question",
                name: "What should Myanmar businesses consider when choosing a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "a. Scalability: Choose a CRM that grows with your business and team expansion. b. Customisation: Ensure it fits your industry-specific workflows and Myanmar sales practices. c. Tool compatibility: Look for integration with WhatsApp, email platforms, and Google Workspace. d. Local support access: Prioritise CRM providers with Myanmar-specific guidance and support. e. Fair pricing: Select a CRM with transparent pricing and real value—no hidden fees.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for Myanmar startups?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud CRM is ideal for Myanmar startups. It's easy to implement, cost-effective, and includes automation tools that help small teams convert leads and scale faster with minimal manual effort.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud CRM work with the tools I already use?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud CRM connects smoothly with widely used tools like Google Workspace, email services, web forms, and marketing platforms, offering a seamless operational ecosystem for Myanmar businesses. Learn more about supported integrations.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM ensure data security for Myanmar businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM uses enterprise-grade encryption and security protocols to protect your data. It helps businesses in Myanmar comply with best practices in data protection and client privacy.",
                },
              },
              {
                "@type": "Question",
                name: "Which CRM platforms are most popular in Myanmar?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "While global CRMs are available, Pepper Cloud CRM is rapidly emerging as the preferred choice among Myanmar SMEs due to its WhatsApp integration, automation, affordability, and dedicated local support.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM affordable for small and medium-sized companies?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Pepper Cloud CRM offers flexible pricing plans to fit businesses at every stage in Myanmar—from bootstrapped startups to scaling enterprises—ensuring maximum value without overpaying for unused features.",
                },
              },
              {
                "@type": "Question",
                name: "What defines the best CRM for small businesses in Myanmar?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The ideal CRM should be affordable, easy to use, scalable, and local-market ready. Pepper Cloud CRM ticks all these boxes, offering an intuitive interface, smart automation, and built-in communication tools to manage sales and customer loyalty efficiently.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Scale smarter with best CRM software in{" "}
              <img className="countryLogo" src={myanmar} alt="myanmar" />{" "}
              <span className="countryHighlight">Myanmar</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Discover the best CRM software in Myanmar built to help businesses
              automate workflows, close more deals, and strengthen customer
              relationships with seamless tools tailored for growing B2B teams.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-driven automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Omnichannel communication
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  WhatsApp CRM integration
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Understanding CRM systems for Myanmar’s growing businesses
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Discover why Pepper Cloud transforms CRM experiences for
              businesses in Myanmar today
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Sell smarter with a powerful feature suite
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM tool for your Myanmar growing business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  " Benefits of using a CRM tool for your Myanmar growing business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Business applications of CRM software across Myanmar
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Training and coaching
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Financial service
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Retail and e-commerce
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              Top 5 CRM software in Myanmar for growing businesses
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQS – Best CRM software in Myanmar"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Turn every lead into a customer with Myanmar’s smartest sales CRM.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Myanmar;
